<template>
  <div>
    <DarkModeSwitcher />
    <MobileMenu />
    <template v-if="loading">
      <LoadingIcon />
    </template>
    <!-- BEGIN: Top Bar -->
    <div
      class="border-b border-theme-24 md:-mt-5 -mx-3 sm:-mx-8 px-3 sm:px-8 pt-3 md:pt-0 mb-4"
    >
      <div class="top-bar-boxed flex items-center">
        <!-- BEGIN: Logo -->
        <router-link
          v-if="
            $store.state.auth.user != null &&
              $store.state.auth.user.isAdmin >= 1
          "
          :to="{ name: 'agency-list' }"
          tag="a"
          class="-intro-x hidden xl:flex"
        >
          <img
            alt="Midone Tailwind HTML Admin Template"
            class="w-6"
            src="@/assets/images/logo.svg"
          />
          <span class="text-white text-lg ml-3">
            <span class="text-2xl">MSN</span>
          </span>
        </router-link>
        <router-link
          v-else
          :to="{ name: 'transaction' }"
          tag="a"
          class="-intro-x hidden xl:flex"
        >
          <img
            alt="Midone Tailwind HTML Admin Template"
            class="w-6"
            src="@/assets/images/logo.svg"
          />
          <span class="text-white text-lg ml-3">
            <span class="text-2xl">MSN</span>
          </span>
        </router-link>
        <!-- END: Logo -->
        <div
          class="overflow-x-auto sm:overflow-x-visible flex flex-col w-full items-center xl:flex-row"
        >
          <!-- BEGIN: Breadcrumb -->
          <template v-if="$h.isset(this.$store.state.auth.user)">
            <div class="-intro-x breadcrumb breadcrumb--light hidden xl:flex">
              <h5 class="text-lg font-medium">
                {{ this.$store.state.auth.user.agencyName }}
              </h5>
            </div>
          </template>
          <!-- END: Breadcrumb -->
          <div
            class="sm:scrollbar-hidden intro-x relative mx-auto xl:w-auto mt-2"
          >
            <div class="flex items-center justify-center">
              <div
                v-if="
                  $store.state.auth.user != null &&
                    $store.state.auth.user.isAdmin == 2
                "
                class="mx-2 w-10 h-10"
                style="cursor: pointer;"
                @click="openDeletedPeriodModal"
              ></div>
              <div
                v-for="(moneyCategory, index) in moneyCategories"
                :key="index"
                class="mx-4"
                style="width: 3.5rem;"
              >
                <div v-if="moneyCategory.code != 'VND'" class="text-center">
                  <img
                    alt="Midone Tailwind HTML Admin Template"
                    class="w-12 mx-auto"
                    :src="require(`@/assets/images/flags/${moneyCategory.img}`)"
                  />
                </div>
                <div
                  v-if="moneyCategory.code != 'VND'"
                  class="text-gray-400 text-lg text-center"
                >
                  {{ moneyCategory.otherToKwrRate }}
                </div>
              </div>
              <div
                v-if="$store.state.main.isShowBtn"
                class="mx-2 pointer w-10 h-10"
                style="cursor: pointer;"
                @click="onClickBlank"
              ></div>
            </div>
          </div>
          <!-- BEGIN: Account Menu -->
          <div class="intro-x dropdown h-8 relative hidden xl:block">
            <div
              class="dropdown-toggle w-10 h-10 overflow-hidden rounded-full bg-theme-6 text-white items-center flex justify-center shadow-lg image-fit zoom-in scale-110"
            >
              <PowerIcon />
            </div>
            <div class="dropdown-box w-40">
              <div
                class="dropdown-box__content box bg-theme-38 dark:bg-dark-6 text-white"
              >
                <div class="p-2 border-t border-theme-40 dark:border-dark-3">
                  <a
                    class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"
                    data-dismiss="dropdown"
                    @click="onClickLogout"
                  >
                    <ToggleRightIcon class="w-4 h-4 mr-2" />
                    로그아웃
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- END: Account Menu -->
        </div>
      </div>
    </div>
    <!-- END: Top Bar -->
    <!-- BEGIN: Top Menu -->
    <nav class="top-nav">
      <ul>
        <!-- BEGIN: First Child -->
        <template v-for="(menu, menuKey) in formattedMenu">
          <li :key="menuKey">
            <a
              href="javascript:;"
              class="top-menu"
              :class="{
                'top-menu--active': menu.active
              }"
              @click="linkTo(menu)"
            >
              <div class="top-menu__icon">
                <component :is="menu.icon" />
              </div>
              <div class="top-menu__title">
                {{ menu.title }}
                <ChevronDownIcon
                  v-if="$h.isset(menu.subMenu)"
                  class="top-menu__sub-icon"
                />
              </div>
            </a>
            <!-- BEGIN: Second Child -->
            <ul v-if="$h.isset(menu.subMenu)">
              <li
                v-for="(subMenu, subMenuKey) in menu.subMenu"
                :key="subMenuKey"
              >
                <a
                  href="javascript:;"
                  class="top-menu"
                  @click="linkTo(subMenu)"
                >
                  <div class="top-menu__icon">
                    <ActivityIcon />
                  </div>
                  <div class="top-menu__title">
                    {{ subMenu.title }}
                    <ChevronDownIcon
                      v-if="$h.isset(subMenu.subMenu)"
                      class="top-menu__sub-icon"
                    />
                  </div>
                </a>
                <!-- BEGIN: Third Child -->
                <ul v-if="$h.isset(subMenu.subMenu)">
                  <li
                    v-for="(lastSubMenu, lastSubMenuKey) in subMenu.subMenu"
                    :key="lastSubMenuKey"
                  >
                    <a
                      href="javascript:;"
                      class="top-menu"
                      @click="linkTo(lastSubMenu)"
                    >
                      <div class="top-menu__icon">
                        <component :is="'zap-icon'" />
                      </div>
                      <div class="top-menu__title">
                        {{ lastSubMenu.title }}
                      </div>
                    </a>
                  </li>
                </ul>
                <!-- END: Third Child -->
              </li>
            </ul>
            <!-- END: Second Child -->
          </li>
        </template>
        <!-- END: First Child -->
      </ul>
    </nav>
    <!-- END: Top Menu -->
    <!-- BEGIN: 기간 삭제 관리 모달 (총괄관리자 전용) -->
    <div id="deleted-period-modal" class="modal">
      <div class="modal__content">
        <div
          class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5 relative"
        >
          <h2 class="font-medium text-base mr-auto">기간 삭제 관리</h2>
          <a
            data-dismiss="modal"
            href="javascript:;"
            class="absolute right-0 top-0 mt-3 mr-3"
          >
            <xIcon class="w-8 h-8 text-gray-500" />
          </a>
        </div>
        <div class="p-5">
          <div class="font-medium mb-2">삭제된 기간</div>
          <div
            v-if="deletedPeriods.length === 0"
            class="text-gray-500 text-center py-3"
          >
            삭제된 기간이 없습니다.
          </div>
          <div
            v-for="period in deletedPeriods"
            :key="period.id"
            class="flex items-center justify-between border-b border-gray-200 dark:border-dark-5 py-2"
          >
            <span>{{ period.startDay }} ~ {{ period.endDay }}</span>
            <a
              href="javascript:;"
              class="text-theme-6"
              title="기간 삭제 취소"
              @click="removeDeletedPeriodItem(period)"
            >
              <xIcon class="w-4 h-4" />
            </a>
          </div>
          <div class="flex items-center mt-5">
            <el-date-picker
              v-model="newPeriodRange"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="~"
              start-placeholder="시작일"
              end-placeholder="종료일"
              value-format="yyyy-MM-dd"
              class="flex-1"
            >
            </el-date-picker>
            <button
              class="button bg-theme-1 text-white ml-2 whitespace-no-wrap"
              @click="addDeletedPeriodItem"
            >
              추가
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- END: 기간 삭제 관리 모달 -->
    <!-- BEGIN: Content -->
    <div class="content">
      <router-view />
    </div>
    <!-- END: Content -->
  </div>
</template>

<script>
import axios from "axios";
import TopBar from "@/components/TopBar";
import MobileMenu from "@/components/MobileMenu";
import DarkModeSwitcher from "@/components/DarkModeSwitcher";
import jQuery from "jquery";
import Toastify from "toastify-js";

export default {
  components: {
    DarkModeSwitcher,
    MobileMenu,
    TopBar
  },
  data() {
    return {
      refreshInterval: null,
      moneyCategories: [],
      formattedMenu: [],
      searchDropdown: false,
      newPeriodRange: null
    };
  },
  computed: {
    passportInfo() {
      return !this.$store.state.main.passportInfo;
    },
    deletedPeriods() {
      return this.$store.state.main.deletedPeriods || [];
    },
    topMenu() {
      return this.nestedMenu(this.$store.state.topMenu.menu);
    },
    topMenuFront() {
      return this.nestedMenu(this.$store.state.topMenuFront.menu);
    },
    loading() {
      return this.$store.state.main.loading;
    }
  },
  watch: {
    $route() {
      if (
        this.$store.state.auth.user != null &&
        this.$store.state.auth.user.isAdmin >= 1
      ) {
        this.formattedMenu = this.$h.assign(this.topMenu);
      } else {
        this.formattedMenu = this.$h.assign(this.topMenuFront);
      }
    }
  },
  async created() {
    await this.tokenLogin();
    //let fullPath = this.$router.currentRoute.fullPath;
    if (!this.$store.state.auth.isLogined) {
      this.$router.replace("/");
    }
  },
  async mounted() {
    await this.tokenLogin();

    cash("body")
      .removeClass("login")
      .addClass("app");
    if (this.$store.state.auth.user != null) {
      if (this.$store.state.auth.user.isAdmin >= 1) {
        this.formattedMenu = this.$h.assign(this.topMenu);
      } else {
        this.formattedMenu = this.$h.assign(this.topMenuFront);
      }
      await this.getMoneyCategories();
      await this.loadDeletedPeriods();
      this.refreshInterval = setInterval(async () => {
        await this.getMoneyCategories();
      }, 3000);
    }
    if (!this.$store.state.auth.isLogined) {
      this.$router.replace("/");
    }
  },
  beforeUnmount() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
  methods: {
    async tokenLogin() {
      let data = {
        token: window.localStorage.getItem("exchange_token")
      };
      let resultData = {};
      await axios.post(this.$api().tokenLogin, data).then(res => {
        resultData = res.data;
      });
      if (this.$h.isEmpty(resultData)) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else if (resultData.error) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else {
        this.$store.commit("auth/SET_USER", resultData.userData);
        this.$store.commit("auth/SET_ISLOGINED", true);
        window.localStorage.setItem(
          "exchange_token",
          resultData.userData.token
        );
      }
    },
    async onClickBlank() {
      // if (this.$store.state.auth.user.isAdmin != 1) {
      if (this.$store.state.main.passportInfo == 1) {
        this.$store.dispatch("main/setPassportInfo", 0);
      } else {
        this.$store.dispatch("main/setPassportInfo", 1);
      }
      jQuery("#test_click_btn").click();
      // }
    },
    async loadDeletedPeriods() {
      try {
        let data = {
          token: this.$h.assign(this.$store.state.auth.user.token)
        };
        await axios.post(this.$api().getDeletedPeriods, data).then(res => {
          this.$store.dispatch(
            "main/setDeletedPeriods",
            this.$h.assign(res.data.data) || []
          );
        });
      } catch (e) {
        // 목록 로드 실패 시 달력 차단만 비활성화될 뿐 다른 기능엔 영향 없음
      }
    },
    openDeletedPeriodModal() {
      this.newPeriodRange = null;
      cash("#deleted-period-modal").modal("show");
    },
    async addDeletedPeriodItem() {
      if (
        !this.newPeriodRange ||
        !this.newPeriodRange[0] ||
        !this.newPeriodRange[1]
      ) {
        return;
      }
      try {
        let data = {
          token: this.$h.assign(this.$store.state.auth.user.token),
          startDay: this.newPeriodRange[0],
          endDay: this.newPeriodRange[1]
        };
        const res = await axios.post(this.$api().addDeletedPeriod, data);
        if (res.data.result === "success") {
          this.newPeriodRange = null;
          await this.loadDeletedPeriods();
        }
      } catch (e) {
        Toastify({
          text: "기간 추가에 실패했습니다.",
          duration: 3000,
          close: true,
          gravity: "bottom",
          position: "left",
          backgroundColor: "#e53231",
          stopOnFocus: true
        }).showToast();
      }
    },
    async removeDeletedPeriodItem(period) {
      if (!confirm("해당 기간 삭제를 취소하시겠습니까?")) {
        return;
      }
      try {
        let data = {
          token: this.$h.assign(this.$store.state.auth.user.token),
          id: period.id
        };
        const res = await axios.post(this.$api().removeDeletedPeriod, data);
        if (res.data.result === "success") {
          await this.loadDeletedPeriods();
        }
      } catch (e) {
        Toastify({
          text: "기간 삭제 취소에 실패했습니다.",
          duration: 3000,
          close: true,
          gravity: "bottom",
          position: "left",
          backgroundColor: "#e53231",
          stopOnFocus: true
        }).showToast();
      }
    },
    async onClickLogout() {
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().logout, data);
      //console.log("refresh");
      this.$router.replace("/");
      window.location.reload();
    },
    async getMoneyCategories() {
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().getMoneyCategories, data).then(res => {
        let resultData = this.$h.assign(res.data);
        this.$store.dispatch("main/setMoneyCategories", resultData.data);
        this.moneyCategories = resultData.data.slice(
          0,
          resultData.data.length - 1
        );
      });
    },
    showSearchDropdown() {
      this.searchDropdown = true;
    },
    hideSearchDropdown() {
      this.searchDropdown = false;
    },
    nestedMenu(menu) {
      menu.forEach((item, key) => {
        if (typeof item !== "string") {
          menu[key].active =
            (item.pageName == this.$route.name ||
              (this.$h.isset(item.subMenu) &&
                this.findActiveMenu(item.subMenu))) &&
            !item.ignore;
        }

        if (this.$h.isset(item.subMenu)) {
          menu[key] = {
            ...item,
            ...this.nestedMenu(item.subMenu)
          };
        }
      });

      return menu;
    },
    findActiveMenu(subMenu) {
      let match = false;
      subMenu.forEach(item => {
        if (item.pageName == this.$route.name && !item.ignore) {
          match = true;
        } else if (!match && this.$h.isset(item.subMenu)) {
          match = this.findActiveMenu(item.subMenu);
        }
      });
      return match;
    },
    linkTo(menu) {
      if (!this.$h.isset(menu.subMenu)) {
        this.$router.push({
          name: menu.pageName
        });
      }
    }
  }
};
</script>
